export default __webpack_public_path__ + "static/media/Inter-Light.00787fe3.ttf";